import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'plaidStatus.description',
    defaultMessage: 'Sending this will send a reminder email to customers that have not yet verified their identity',
  },
  resendIdentityVerificationButton: {
    id: 'plaidStatus.resendIdentityVerificationButton',
    defaultMessage: 'Resend identity verification',
  },
  resendIdentityVerificationSuccess: {
    id: 'plaidStatus.resendIdentityVerificationSuccess',
    defaultMessage: 'Identity verification email sent',
  },
  title: {
    id: 'plaidStatus.title',
    defaultMessage: 'IDV (Plaid Status)',
  },
  disabled: {
    id: 'plaidStatus.disabled',
    defaultMessage: 'ID Verification feature is currently disabled',
  },
});

export default messages;
